import Vue from "vue";
import App from "./App.vue";
import router from "./router";
//import VueRouter from "vue-router";
import store from "./store";
import NProgress from "vue-nprogress";
import AuthService from "./services/auth";
import "./registerServiceWorker";
import "./global.scss";
import Axios from "axios";
import Moment from "vue-moment";
//import InfiniteLoading from "vue-infinite-loading";

import {
  Affix,
  Alert,
  AutoComplete,
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Calendar,
  Card,
  Carousel,
  Cascader,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Drawer,
  Dropdown,
  Form,
  Icon,
  Input,
  InputNumber,
  Layout,
  List,
  Menu,
  Message,
  notification,
  Pagination,
  Progress,
  Popconfirm,
  Radio,
  Rate,
  Row,
  Select,
  Skeleton,
  Slider,
  Spin,
  Steps,
  Switch,
  Table,
  Tabs,
  Tag,
  Tooltip,
  TreeSelect,
  Upload
} from "ant-design-vue";

Vue.use(Alert);
Vue.use(Affix);
Vue.use(AutoComplete);
Vue.use(Avatar);
Vue.use(Badge);
Vue.use(Button);
Vue.use(Breadcrumb);
Vue.use(Card);
Vue.use(Calendar);
Vue.use(Carousel);
Vue.use(Cascader);
Vue.use(Checkbox);
Vue.use(Col);
Vue.use(Collapse);
Vue.use(DatePicker);
Vue.use(Divider);
Vue.use(Dropdown);
Vue.use(Drawer);
Vue.use(Form);
Vue.use(Icon);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Layout);
Vue.use(List);
Vue.use(Menu);
Vue.use(Message);
Vue.use(notification);
Vue.use(Pagination);
Vue.use(Popconfirm);
Vue.use(Progress);
Vue.use(Radio);
Vue.use(Rate);
Vue.use(Row);
Vue.use(Spin);
Vue.use(Select);
Vue.use(Skeleton);
Vue.use(Slider);
Vue.use(Steps);
Vue.use(Switch);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Table);
Vue.use(Tooltip);
Vue.use(TreeSelect);
Vue.use(Upload);
Vue.prototype.$notification = notification;
Vue.use(NProgress);
Vue.use(AuthService);
Vue.use(Moment);
//Vue.use(InfiniteLoading);

Vue.config.productionTip = false;
const nprogress = new NProgress({ parent: "body" });
Vue.prototype.$axios = Axios.create({
  baseURL: process.env.VUE_APP_BACKEND_BASE_URL,
  validateStatus: function(status) {
    return status >= 200 && status <= 503;
  }
});
Vue.prototype.$axiosDecidir = Axios.create({
  baseURL: process.env.VUE_APP_DECIDIR_BASE_URL
});
Vue.prototype.$axiosDecidir.defaults.headers.common = {
  apikey: process.env.VUE_APP_DECIDIR_PUBLIC_API_KEY
};
Vue.prototype.$axiosHarmony = Axios.create({
  baseURL: process.env.VUE_APP_HARMONY_BASE_URL
});
/*Vue.prototype.$axiosHarmony.defaults.headers.common = {  Authorization: process.env.VUE_APP_HARMONY_PUBLIC_API_KEY};*/
new Vue({
  router,
  store,
  nprogress,
  render: h => h(App)
}).$mount("#app");
